module.exports = __webpack_public_path__ + "assets/point-black.dec5d89d.svg";